const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'DEV';

const CONFIG = {
  ENVIRONMENT,
  API_BASE_URL:
    ENVIRONMENT === 'PRD'
      ? process.env.REACT_APP_API_BASE_URL_PRD
      : ENVIRONMENT === 'TEST'
        ? process.env.REACT_APP_API_BASE_URL_TEST
        : process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:5001/api',
};

console.log(`🔧 MiSDAgenda | Ambiente: ${CONFIG.ENVIRONMENT}`);
console.log(`📡 API: ${CONFIG.API_BASE_URL}`);

export default CONFIG;
